'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import { StandardHero } from './StandardHero';
import { getActiveGovTradesTab } from './getActiveGovTradesTab';

export const GovTradesHero = ({ search }: { search: React.ReactNode }) => {
  const pathname = usePathname() ?? '';
  const activeTab = getActiveGovTradesTab(pathname);
  if (!activeTab) return null;
  return <StandardHero activeTab={activeTab} search={search} url={`https://www.benzinga.com${pathname}`} />;
};
